import { render, staticRenderFns } from "./DoorTip.vue?vue&type=template&id=a0b50f82&scoped=true"
import script from "./DoorTip.vue?vue&type=script&lang=js"
export * from "./DoorTip.vue?vue&type=script&lang=js"
import style0 from "./DoorTip.vue?vue&type=style&index=0&id=a0b50f82&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b50f82",
  null
  
)

export default component.exports